import { postSetGaData } from 'PrivateAPI';

import { ConfigStateStatic } from 'Context/config';

export const getGACid = () => window?.ga?.getAll?.()?.[0]?.get?.('clientId');

const setGAData = ({ enquiry }) => {
  const { gclid } = ConfigStateStatic.state;

  postSetGaData({
    enquiryId: enquiry.id,
    ga_cid: getGACid(),
    gclid,
  });
};

export default setGAData;
